(() => {
  const addWorldCupLink = () => {
    document.querySelectorAll('.sf-nav__item').forEach((item) => {
      const trigger = item.querySelector(':scope > .sf-nav__trigger-row .sf-nav__link, :scope > .sf-nav__link');
      if (trigger?.textContent.trim().toUpperCase() !== 'JERSEYS') return;
      const dropdown = item.querySelector(':scope > .sf-dropdown');
      if (!dropdown || dropdown.querySelector('a[href="/collections/world-cup-2026"]')) return;
      const newLink = document.createElement('a');
      newLink.href = '/collections/world-cup-2026';
      newLink.textContent = 'World Cup 2026';
      const newDrops = dropdown.querySelector('a[href="/collections/new-26-27"]');
      if (newDrops) newDrops.insertAdjacentElement('afterend', newLink);
      else dropdown.prepend(newLink);
    });

    document.querySelectorAll('.sf-mobile-nav__group').forEach((group) => {
      const trigger = group.querySelector(':scope > .sf-mobile-nav__row .sf-mobile-nav__link');
      if (trigger?.textContent.trim().toUpperCase() !== 'JERSEYS') return;
      const children = group.querySelector(':scope > .sf-mobile-nav__children');
      if (!children || children.querySelector('a[href="/collections/world-cup-2026"]')) return;
      const newLink = document.createElement('a');
      newLink.className = 'sf-mobile-nav__grandchild';
      newLink.href = '/collections/world-cup-2026';
      newLink.textContent = 'World Cup 2026';
      newLink.setAttribute('data-sf-mobile-close', '');
      const newDrops = children.querySelector('a[href="/collections/new-26-27"]');
      if (newDrops) newDrops.insertAdjacentElement('afterend', newLink);
      else children.prepend(newLink);
    });
  };

  const applyAfterHeaderSetup = () => window.setTimeout(addWorldCupLink, 0);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAfterHeaderSetup, { once: true });
  else applyAfterHeaderSetup();
})();
